<template>
  <div class="">

    <footer id="footer-area" class="footer-area pt-100">
      <div class="container">
        <div class="row">
          <div class="col-sm-6 col-lg-4">
            <div class="footer-item">
              <div class="footer-logo">

                <router-link :to="'/home'" class="logo">
                  <img src="/assets/img/logo.png" class="logo" alt="Logo">
                </router-link>

                <p class="bio-setting"></p>

                <ul>
                  <li>
                    <a href="http://gatetechs.com" target="_blank">
                      <i :class="'icofont-facebook'"></i>
                    </a>
                  </li>
                  <li>

                    <a href="http://gatetechs.com" target="_blank">
                      <i :class="'icofont-twitter'"></i>
                    </a>
                  </li>
                  <li>

                    <a href="http://gatetechs.com" target="_blank">
                      <i :class="'icofont-instagram'"></i>
                    </a>
                  </li>
                </ul>

              </div>
            </div>
          </div>

          <div class="col-sm-6 col-lg-4">
            <div class="footer-item">
              <div class="footer-links">
                <h3>{{ $t('app.support') }}</h3>
                <ul>
                  <li class="nav-item" v-for="(item, idx) in supports" :key="idx">
                    <router-link :to="'/' + item.slug" class="nav-link">
                      <i class="icofont-simple-right"></i>
                      {{ ($i18n.locale == 'en') ? item.en.title : item.ar.title }}
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-lg-4">
            <div class="footer-item footer-item-contact">
              <div class="footer-contact">
                <h3>{{ $t('app.contactInfo') }}</h3>
                <div class="contact-inner">
                  <ul>
                    <li>
                      <i class="icofont-ui-email"></i>
                      <a style="display: inline-block;" href="javascript:;" class="email-setting">
                        info@2payme.com
                      </a>
                    </li>
                    <br />
                    <li>
                      <a style="display: inline-block;" class="phone-link">
                        <i class="icofont-phone"></i> +96592244785
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="copyright-area">
          <p>
            {{ $t('app.copyright') }} &copy; {{new Date().getFullYear()}} <a href="https://gatetechs.com/" style="color: #F7B933;" rel="noopener noreferrer" target="_blank">{{ $t('app.gatetechs') }}</a>
          </p>
        </div>

      </div>
    </footer>

    <div class="go-top">
      <i class="icofont-arrow-up"></i>
      <i class="icofont-arrow-up"></i>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Footer',
  components: {},
  data() {
    return {
      //
      settings: {
        phone: '+96592244785',
        email: 'info@2payme.com',
        en: {
          address: '',
        },
        ar: {
          address: '',
        }
      },
      pgLoading: false,
      pages: [],
      supports: [],
    }
  },
  mounted() {
  },
  created() {
    //
    // if (localStorage.getItem('settings.phone')) {
    //   this.settings.phone = localStorage.getItem('settings.phone');
    // }
    // if (localStorage.getItem('settings.email')) {
    //   this.settings.email = localStorage.getItem('settings.email');
    // }

    // if (localStorage.getItem('settings.en.address')) {
    //   this.settings.en.address = localStorage.getItem('settings.en.address');
    // }
    // if (localStorage.getItem('settings.ar.address')) {
    //   this.settings.ar.address = localStorage.getItem('settings.ar.address');
    // }

    this.fetchPages();
    this.fetchSupports();
  },
  methods: {
    //

    fetchPages() {
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + '/pages',
        method: 'GET',
        data: {},
        params: {
          ShowInFooter: true
        },
        headers: {
          appId: process.env.VUE_APP_APPID
        },
      }
      this.axios(options)
        .then(res => {
          this.pgLoading = false;
          this.pages = res.data.data.rows;
        })
        .catch(() => {
          //
        })
        .finally(() => {

        });
    },

    fetchSupports() {
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + '/pages',
        method: 'GET',
        data: {},
        params: {
          ShowInSupport: true
        },
        headers: {
          appId: process.env.VUE_APP_APPID
        },
      }
      this.axios(options)
        .then(res => {
          this.pgLoading = false;
          this.supports = res.data.data.rows;
        })
        .catch(() => {
          //
        })
        .finally(() => {
          if (localStorage.getItem('locale') == 'ar') {
            document.getElementById("footer-area").classList.add('is-rtl');
          }
        });
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer-item *,
.bio-setting * {
  text-align: -webkit-center !important;
}


.nav-link {
  display: block;
  padding: 0.5rem 0;
}
</style>
